import { render, staticRenderFns } from "./choose-people.vue?vue&type=template&id=0145ab48&"
import script from "./choose-people.vue?vue&type=script&lang=js&"
export * from "./choose-people.vue?vue&type=script&lang=js&"
import style0 from "./choose-people.vue?vue&type=style&index=0&id=0145ab48&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports